import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import "./Layout.css";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("activeMenu") || "home");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.startsWith("/home")) setActiveMenu("leads");
    else if (currentPath.startsWith("/integration")) setActiveMenu("integration");
    else if (currentPath.startsWith("/leads")) setActiveMenu("leads");
  }, [location.pathname]);

  const handleMenuClick = (menu, path) => {
    setActiveMenu(menu);
    localStorage.setItem("activeMenu", menu);
    navigate(path);
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="layout-container">
      <aside className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <span className="logo">📊</span>
          <h2>LeadBank</h2>

          <div className="toggle-icon" onClick={toggleSidebar}>
            <span className="material-symbols-outlined">
              {isSidebarCollapsed ? "menu" : "close"}
            </span>
          </div>
        </div>

        <ul className="menu">
          {/* <li
            className={activeMenu === "home" ? "active" : ""}
            onClick={() => handleMenuClick("home", "/home")}
          >
            <span className="material-symbols-outlined">description</span>
            <span className="text">Forms</span>
          </li> */}
          <li
            className={activeMenu === "integration" ? "active" : ""}
            onClick={() => handleMenuClick("integration", "/integration")}
          >
            <span className="material-symbols-outlined">settings</span>
            <span className="text">Integration</span>
          </li>
          <li
            className={activeMenu === "leads" ? "active" : ""}
            onClick={() => handleMenuClick("leads", "/leads")}
          >
            <span className="material-symbols-outlined">groups</span>
            <span className="text">Lead Source</span>
          </li>
        </ul>

        <div
          className="logout"
          onClick={() => {
            localStorage.clear();
            navigate("/");
          }}
        >
          <span className="material-symbols-outlined">logout</span>
          <span className="text">Logout</span>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
